import axios from "axios";
import "../Axios/AxiosConfig"; // ensures global session interceptor is registered
import {
  downloadIndividualClients,
  salesManagement,
  STKPushAttempt,
  uploadIndividualClients,
} from "../../config";
import {
  generateAndExecuteMutation,
  generateAndExecuteMutationreturn,
} from "../Axios/DynamicService";
import { Typography } from "@mui/material";
import Swal from "sweetalert2";
import { Payment } from "@mui/icons-material";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "application/json",
  };
};

const uploadDocumentsAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "multipart/form-data",
  };
};
const downloadDocumentsAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "application/json", // Set this to JSON for download requests
  };
};

export async function uploadIndividualClient(file) {
  const baseurlupload = uploadIndividualClients.uri;
  const headers = uploadDocumentsAuthHeaders();
  const postData = {
    file,
  };

  try {
    const response = await axios.post(baseurlupload, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}

export async function generateReports(parameters, reportUrl) {
  const headers = getAuthHeaders();
  const base_url = reportUrl;
  const postData = parameters;

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}

export async function generateReport(formData, reportUrl, setLoading) {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const headers = {
    "Content-Type": "application/json",
    // Uncomment the following lines if you need these headers
    Authorization: formattedToken,
    "Access-Control-Allow-Headers": "authorization,content-type",
    "Access-Control-Allow-Methods": "POST",
    "Access-Control-Allow-Origin": "*",
    Origin: "https://matrix.mcb.co.ke",
    referrerPolicy: "no-referrer-when-downgrade",
  };

  try {
    // Start the loading animation
    setLoading(true);

    const response = await fetch(reportUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response;
  } catch (error) {
    console.error("Error:", error);
    return error;
  } finally {
    // Stop the loading animation
    setLoading(false);
  }
}

export async function mpesaPay(orderId, AmountToPay, phoneNumber, branchId) {
  const headers = getAuthHeaders();
  const base_url = STKPushAttempt.uri;
  const postData = {
    orderId,
    AmountToPay,
    phoneNumber,
    branchId,
  };

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}

export const handleApproveDisapprovePaymentVoucher = async (
  id,
  actions,
  flag,
) => {
  try {
    // Show confirmation dialog
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${flag === 0 ? "Disapprove" : flag === 3 ? "Reverse" : "Approve"} Payment Voucher?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes, ${flag === 0 ? "Disapprove" : flag === 3 ? "Reverse" : "Approve"} it!`,
      cancelButtonText: "No, keep it",
    });

    // If user confirms the action
    if (confirmation.isConfirmed) {
      let reason = null;

      // Show dialog to input reason only if flag is 3 (Reverse)
      if (flag === 3) {
        const reasonDialog = await Swal.fire({
          title: "Enter Reason",
          input: "textarea",
          inputLabel: "Reason for Reversal",
          inputPlaceholder: "Enter your reason here...",
          inputAttributes: {
            "aria-label": "Enter your reason here",
          },
          showCancelButton: true,
          confirmButtonText: "Submit",
          cancelButtonText: "Cancel",
          inputValidator: (value) => {
            if (!value) {
              return "You need to provide a reason!";
            }
          },
        });

        // If reason dialog is cancelled, exit
        if (!reasonDialog.isConfirmed) {
          return;
        }

        reason = reasonDialog.value;
      }

      let mutationData = null;

      mutationData = {
        [actions.approveddisapprovedpv.modelName]: id,
        flag: flag,
      };

      if (flag === 3) {
        mutationData = {
          [actions.reversePaymentVoucher.modelName]: id,
          reason: reason, // Add the reason for reversal
        };
      }

      const inputName =
        flag === 3
          ? actions.reversePaymentVoucher.inputObjectName
          : actions.approveddisapprovedpv.inputObjectName;
      const subInputName =
        flag === 3
          ? actions.reversePaymentVoucher.inputSubObjectName
          : actions.approveddisapprovedpv.inputSubObjectName;

      // Execute mutation with the updated approval state
      const response = await generateAndExecuteMutationreturn(
        inputName,
        mutationData,
        actions.returnFields,
        subInputName,
        salesManagement.uri,
      );

      return response;
    }
  } catch (error) {
    // Handle error case
    Swal.fire({
      icon: "error",
      title: "Error!",
      text:
        error.name === "AxiosError"
          ? error.response.data.errors[0].message
          : "An error occurred while processing your request. Please try again later.",
    });
  }
};

export const handleReverseSaleOrder = async (id, actions, flag) => {
  try {
    // Show confirmation dialog with reason input
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to Reverse ${flag === 0 ? "Sale Order Item" : "Sale Order"}?`,
      icon: "warning",
      input: "textarea",
      inputLabel: "Reason for Reversal",
      inputPlaceholder: "Please provide a reason for reversing this order...",
      inputValidator: (value) => {
        if (!value || value.trim() === "") {
          return "You need to provide a reason for the reversal!";
        }
      },
      showCancelButton: true,
      confirmButtonText: `Yes, Reverse it!`,
      cancelButtonText: "No, keep it",
    });

    // If user confirms the action
    if (confirmation.isConfirmed) {
      const reversalReason = confirmation.value;

      let mutationData = null;
      if (flag === 1) {
        mutationData = {
          orderId: id.saleOrderId,
          reason: reversalReason,
        };
      } else {
        mutationData = {
          orderId: id.saleOrder,
          saleOrderItemId: id.id,
          reason: reversalReason,
        };
      }

      const modulename = {
        modulename:
          flag === 1
            ? actions.reversesaleOrder.ModuleNames
            : actions.reversesaleOrderItem.ModuleNames,
        inputObjectName:
          flag === 1
            ? actions.reversesaleOrder.inputObjectName
            : actions.reversesaleOrderItem.inputObjectName,
      };

      // Execute mutation with the updated approval state
      const response = await generateAndExecuteMutationreturn(
        modulename.modulename,
        mutationData,
        "",
        modulename.inputObjectName,
        salesManagement.uri,
      );

      return response;
    }
  } catch (error) {
    // Handle error case
    Swal.fire({
      icon: "error",
      title: "Error!",
      text:
        error.name === "AxiosError"
          ? error.response.data.errors[0].message
          : "An error occurred while processing your request. Please try again later.",
    });
  }
};

export const handleAddMpesaCode = async (id, actions, flag) => {
  try {
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to Add Mpesa Code to this Sale Order Item?",
      icon: "warning",
      input: "textarea",
      inputLabel: "Adding Mpesa Code",
      inputPlaceholder: "Please provide the Mpesa code...",
      inputValue: id.mpesaCode || "", // Auto-fill if it exists
      inputValidator: (value) => {
        if (!value || value.trim() === "") {
          return "You need to provide the Mpesa code!";
        }
      },
      showCancelButton: true,
      confirmButtonText: "Yes, Add Mpesa Code!",
      cancelButtonText: "No, keep it",
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    const mutationData = {
      saleOrderItemId: id.id,
      mpesaCode: confirmation.value,
    };

    const modulename = {
      modulename: actions.addMpesaCode.ModuleNames,
      inputObjectName: actions.addMpesaCode.inputObjectName,
    };

    return await generateAndExecuteMutationreturn(
      modulename.modulename,
      mutationData,
      "",
      modulename.inputObjectName,
      salesManagement.uri
    );
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text:
        error.name === "AxiosError"
          ? error.response.data.errors[0].message
          : "An error occurred while processing your request. Please try again later.",
    });
  }
};

